import { useState } from "react";
import { ArrowRight } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { LogoMark } from "./Logo";
import { API, scrollToId } from "../lib/site";

const EXPLORE = [
  { label: "Mission", href: "#mission" },
  { label: "Progress", href: "#progress" },
  { label: "Programs", href: "#programs" },
  { label: "Impact", href: "#impact" },
  { label: "Donate", href: "#donate" },
];

const PROGRAMS = [
  "Emergency Food Relief",
  "Family Housing Stability",
  "Global Child Education",
  "Urgent Healthcare Access",
];

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("You're on the list", {
        description: "Monthly field notes from the Million Hope Initiative — no spam, ever.",
      });
      setEmail("");
    } catch (err) {
      toast.error("Subscription failed", { description: "Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="footer-main" className="bg-night text-[#FAF7F2]">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-24">
        <div className="flex flex-wrap items-end justify-between gap-10 border-b border-white/10 pb-14">
          <h2 className="max-w-md font-serif text-5xl font-medium leading-[1.05] tracking-tight sm:text-6xl">
            Give <em className="text-warm">hope.</em>
          </h2>
          <form onSubmit={subscribe} className="w-full max-w-md">
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#FAF7F2]/50">
              Field notes, monthly
            </p>
            <div className="mt-3 flex overflow-hidden rounded-full border border-white/15 bg-white/5 focus-within:border-warm">
              <input
                data-testid="input-newsletter-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.org"
                className="w-full bg-transparent px-5 py-3.5 text-sm text-[#FAF7F2] outline-none placeholder:text-[#FAF7F2]/40"
              />
              <button
                data-testid="btn-submit-newsletter"
                type="submit"
                disabled={loading}
                aria-label="Subscribe"
                className="flex items-center gap-2 bg-warm px-6 text-sm font-semibold text-night transition-colors hover:bg-brand disabled:opacity-50"
              >
                {loading ? "…" : <ArrowRight className="h-4 w-4" />}
              </button>
            </div>
          </form>
        </div>

        <div className="grid gap-10 py-14 sm:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <LogoMark size={30} />
              <span className="font-serif text-xl font-semibold">DAIO</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#FAF7F2]/60">
              Direct Assistance International Organizations — a New Jersey
              nonprofit helping poor families and underprivileged communities,
              at home and abroad.
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#FAF7F2]/50">
              Explore
            </p>
            <ul className="mt-4 space-y-2.5">
              {EXPLORE.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    onClick={() => scrollToId(l.href)}
                    className="text-sm text-[#FAF7F2]/75 transition-colors hover:text-warm"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#FAF7F2]/50">
              Programs
            </p>
            <ul className="mt-4 space-y-2.5">
              {PROGRAMS.map((p) => (
                <li key={p} className="text-sm text-[#FAF7F2]/75">
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8 font-mono text-[10px] uppercase tracking-[0.18em] text-[#FAF7F2]/40">
          <span>© 2026 Direct Assistance International Organizations</span>
          <span>501(c)(3) Nonprofit · Newark, NJ · EIN 45-3932747</span>
        </div>
      </div>
    </footer>
  );
};
